<template>
    <div class="foot">
        <div class="footcontainer">
            <div class="footmenu">
                <div class="footlogo">
                    <div class="medialogo">
                        <a target="_blank" href="http://www.hrflag.com"><img src="http://hrflag.com/img/zqlogowt.svg" alt=""></a>
                    </div>
                    <div class="mediabody">
                        <p>编制和发布</p>
                    </div>
                </div>
                <span class="line">导航</span>
                <router-link to="/">首页</router-link>
                <router-link to="/zongshu">研究综述</router-link>
                <router-link to="/brand">品牌榜</router-link>
                <router-link to="/country">国别分类排名</router-link>
                <router-link to="/sector">细分领域排名</router-link>
                <router-link to="/download">报告下载</router-link>
                <router-link to="/sources">榜单方法论</router-link>
                <router-link to="/copyright">版权声明</router-link>
                <router-link to="/organization">发布机构</router-link>
                <router-link to="/contact">联系我们</router-link>
                <router-link to="/english">ENGLISH</router-link>
                <span class="line">联系我们</span>
                <div class="foot-contact">
                    <span class="adress">上海： </span>
                    <a class="duan" target="_blank" href="tel:021-68405597">
                        <Icon type="ios-telephone"></Icon> <span>021-68405597</span>
                    </a>
                    <a class="duan" target="_blank" href="mailto:mag@hrflag.com">
                        <Icon type="email"></Icon> <span>mag@hrflag.com</span>
                    </a>
                    <a href="javascript:;">
                        <Icon type="ios-location"></Icon> <span>上海市浦东新区世纪大道1777号东方希望大厦10E室</span>
                    </a>
                </div>
                <div class="foot-contact">
                    <span class="adress madress">北京： </span>
                    <a class="duan" target="_blank" href="tel:18701650657">
                        <Icon type="ios-telephone"></Icon> <span>18701650657</span>
                    </a>
                    <a class="duan" target="_blank" href="mailto:dove@hrflag.com">
                        <Icon type="email"></Icon> <span>dove@hrflag.com</span>
                    </a>
                    <a href="javascript:;">
                        <Icon type="ios-location"></Icon> <span>北京市朝阳区霄云路40号国航世纪大厦3层</span>
                    </a>
               </div>
               <div class="foot-contact">
                 <span class="adress madress">深圳： </span>
                 <a class="duan" target="_blank" href="tel:021-68403801">
                   <Icon type="ios-telephone"></Icon> <span>021-68403801</span>
                 </a>
                 <a class="duan" target="_blank" href="mailto:celine.wang@hrflag.com">
                   <Icon type="email"></Icon> <span>celine.wang@hrflag.com</span>
                 </a>
                 <a href="javascript:;">
                   <Icon type="ios-location"></Icon> <span>深圳市南山区高新南一道6号TCL大厦B座9层</span>
                 </a>
               </div>
            </div>

            <div class="footer"></div>
           <!-- <div class="icp">
                <a href="javascript:;">HRflag Corp. © 2022　沪ICP备19003683号</a>
            </div> -->
        </div>
    </div>
</template>

<script>
  import "../../assets/iconfont/iconfont.css"

  import $ from 'jquery'
export default {
    name: 'footbar',
    data () {
        return {

        }
    },
    mounted() {
      this._getfoot()
    },

    methods: {

      _getfoot(){
      			foot($('.footer')).then(function(data){
      				console.log(data)
      			}.bind(this));
      		},


    }
}
</script>

<style scoped>
    .foot {
        width: 100%;
        background-color: #333333;
        padding: 0 0 20px 0;
        z-index: 3;
    }
    .footcontainer {
        max-width: 1440px;
        margin: 0 auto;
        text-align: left;
        padding: 30px 50px;
    }
    .footmenu .footlogo{
        width: 200px;
        margin: 0 auto;
    }
    .footlogo img {
        width: 100px;
        margin-right: 10px;
    }
    .footlogo .medialogo {
        display: table-cell;
        vertical-align: middle;
    }
    .footlogo .medialogo a {
        margin:0;
    }
    .footlogo .mediabody {
        display: table-cell;
        vertical-align: middle;
    }
    .mediabody p {
        color: #ffffff;
        font-size: 14px;
        padding-left: 10px;
    }
    .footmenu a{
        font-weight: normal;
        margin-right: 45px;
        font-size: 16px;
        color: #fff;
        line-height: 3;
        display: inline-block;
    }
    .foot-contact span.adress {
        color: #999;
        font-size: 14px;
        font-weight: bold;
    }
    .foot-contact a {
        display: inline-block;
        color: #999;
        line-height: 2.5;
        width: auto;
        font-size: 14px;
        vertical-align: middle;
    }
    .foot-contact a.duan {
        width: 180px;
    }
    .foot-contact a i {
        vertical-align: middle;
        font-size: 18px;
    }
     .foot-contact a span {
         vertical-align: middle;
     }
     .footmenu a:hover {
         color: #1e6da6;
     }
     .footmenu .line {
        display: inline-block;
        padding: 0 0 0.5em 0;
        width: 100%;
        margin: .8em 0.5em 1em 0;
        text-align: left;
        color: #848484;
        opacity: 0.9;
        border-bottom: 2px solid;
        font-weight: bold;
    }
    .footcontainer .icp {
        text-align: center;
        margin-top: 50px;
    }
    .icp a {
        color:#848484;
    }
    @media screen and (max-width:768px) {
         .foot {
            min-width: 320px;
            padding: 0 10px;
        }
        .footcontainer {
            width: 100%;
            padding: 15px 0;
        }
         .footmenu a {
            font-size: 14px;
            color: #fff;
            display: inline-block;
            width: 32%;
            margin: 0;
            line-height: 2;
        }
        .foot-contact a {
            color: #999;
        }
        .mediabody p {
            color: #ffffff;
            font-size: 14px;
        }
        .foot-contact span.madress {
            margin-top: 10px;
            display: block;
        }
        .foot-contact a {
            display: block;
            width: 100%;
        }
        .icp a {
            color: #848484;
            font-size: 12px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/public/footbar.vue